var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPayments = function SvgPayments(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "payments_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#payments_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.567 24.135a2.18 2.18 0 0 1-1.596-.664 2.18 2.18 0 0 1-.663-1.596V10.433q0-.399.27-.668.27-.27.667-.27.4 0 .668.27.27.27.27.668v11.442q0 .144.12.265.12.12.264.12H23.03q.398 0 .668.27t.27.668-.27.668a.9.9 0 0 1-.668.269zm4.375-4.375a2.18 2.18 0 0 1-1.596-.664 2.18 2.18 0 0 1-.663-1.596V8.03q0-.932.663-1.596a2.18 2.18 0 0 1 1.596-.663h16.49q.933 0 1.596.663.664.664.664 1.596V17.5q0 .933-.664 1.596a2.18 2.18 0 0 1-1.596.664zm1.875-1.875q0-.935-.664-1.598a2.18 2.18 0 0 0-1.595-.662V17.5a.37.37 0 0 0 .114.27.37.37 0 0 0 .27.115zm12.74 0h1.875a.37.37 0 0 0 .27-.115.37.37 0 0 0 .115-.27v-1.875q-.935 0-1.597.664a2.18 2.18 0 0 0-.662 1.596m-6.37-1.996q1.31 0 2.218-.907t.907-2.217-.907-2.218-2.218-.907-2.217.907-.908 2.217.908 2.218 2.217.908m-8.63-5.985q.936 0 1.598-.664.662-.663.662-1.595H8.942a.37.37 0 0 0-.27.114.37.37 0 0 0-.114.27zm17.26 0V8.029a.37.37 0 0 0-.114-.27.37.37 0 0 0-.27-.114h-1.875q0 .934.663 1.597.665.662 1.596.662"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPayments);
export default ForwardRef;